/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".base-button[_ngcontent-%COMP%]{display:inline-flex;align-items:center;text-decoration:none;transition:opacity linear .3s}.base-button[_ngcontent-%COMP%]:hover{opacity:.8}.base-button__link[_ngcontent-%COMP%]{font-size:16px;font-weight:400;color:var(--text-color,var(--bg-font-color));text-decoration:none}.base-button__arrow[_ngcontent-%COMP%]{fill:var(--link-color);width:15px;transform:rotate(180deg);margin-left:8px}.base-button__arrow[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]{display:block}"];
export { styles as styles };
